module.exports = __webpack_public_path__ + "static/media/close.7606c40d.svg";